import { Component } from '@angular/core';

@Component({
  selector: 'app-login-frame',
  templateUrl: './login-frame.component.html',
  styleUrls: ['./login-frame.component.scss']
})
export class LoginFrameComponent {

}
